import { render, staticRenderFns } from "./MapRecorderWin.vue?vue&type=template&id=28b5e36a&"
import script from "./MapRecorderWin.vue?vue&type=script&lang=js&"
export * from "./MapRecorderWin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports